webpackJsonp([1],{

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(165)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(177),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Post__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Post___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Post__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PostList__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PostList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_PostList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Footer__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Footer__);

//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_2__components_Header___default.a,
    Post: __WEBPACK_IMPORTED_MODULE_3__components_Post___default.a,
    PostList: __WEBPACK_IMPORTED_MODULE_4__components_PostList___default.a,
    AppFooter: __WEBPACK_IMPORTED_MODULE_5__components_Footer___default.a
  },

  data: function data() {
    return {
      posts: [],
      newPost: {
        title: '',
        text: ''
      }
    };
  },


  methods: {
    addPost: function addPost(post) {
      console.log('post', post);
      post.created_at = __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('DD MMM, YYYY HH:mm:ss');
      this.posts.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, post));
    }
  }
});

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app-footer'
});

/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app-header',
	data: function data() {
		return {
			title: 'Vue Blog',
			subtitle: 'Simple Blog Application with Vue.js'
		};
	}
});

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'post',

  data: function data() {
    return {
      newPost: {
        title: '',
        text: ''
      }
    };
  },


  methods: {
    addPost: function addPost() {
      this.$parent.addPost(this.newPost);

      this.newPost.title = '';
      this.newPost.text = '';
    }
  }
});

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'postitem',
  props: ['post', 'index'],
  methods: {
    removePost: function removePost(index) {
      this.$parent.removePost(index);
    }
  }
});

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostItem__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PostItem__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'postlist',
	props: ['posts'],
	components: {
		PostItem: __WEBPACK_IMPORTED_MODULE_0__PostItem___default.a
	},
	methods: {
		removePost: function removePost(index) {
			this.posts.splice(index, 1);
		}
	}
});

/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 164:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 165:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 166:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 167:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 11,
	"./af.js": 11,
	"./ar": 18,
	"./ar-dz": 12,
	"./ar-dz.js": 12,
	"./ar-kw": 13,
	"./ar-kw.js": 13,
	"./ar-ly": 14,
	"./ar-ly.js": 14,
	"./ar-ma": 15,
	"./ar-ma.js": 15,
	"./ar-sa": 16,
	"./ar-sa.js": 16,
	"./ar-tn": 17,
	"./ar-tn.js": 17,
	"./ar.js": 18,
	"./az": 19,
	"./az.js": 19,
	"./be": 20,
	"./be.js": 20,
	"./bg": 21,
	"./bg.js": 21,
	"./bn": 22,
	"./bn.js": 22,
	"./bo": 23,
	"./bo.js": 23,
	"./br": 24,
	"./br.js": 24,
	"./bs": 25,
	"./bs.js": 25,
	"./ca": 26,
	"./ca.js": 26,
	"./cs": 27,
	"./cs.js": 27,
	"./cv": 28,
	"./cv.js": 28,
	"./cy": 29,
	"./cy.js": 29,
	"./da": 30,
	"./da.js": 30,
	"./de": 33,
	"./de-at": 31,
	"./de-at.js": 31,
	"./de-ch": 32,
	"./de-ch.js": 32,
	"./de.js": 33,
	"./dv": 34,
	"./dv.js": 34,
	"./el": 35,
	"./el.js": 35,
	"./en-au": 36,
	"./en-au.js": 36,
	"./en-ca": 37,
	"./en-ca.js": 37,
	"./en-gb": 38,
	"./en-gb.js": 38,
	"./en-ie": 39,
	"./en-ie.js": 39,
	"./en-nz": 40,
	"./en-nz.js": 40,
	"./eo": 41,
	"./eo.js": 41,
	"./es": 43,
	"./es-do": 42,
	"./es-do.js": 42,
	"./es.js": 43,
	"./et": 44,
	"./et.js": 44,
	"./eu": 45,
	"./eu.js": 45,
	"./fa": 46,
	"./fa.js": 46,
	"./fi": 47,
	"./fi.js": 47,
	"./fo": 48,
	"./fo.js": 48,
	"./fr": 51,
	"./fr-ca": 49,
	"./fr-ca.js": 49,
	"./fr-ch": 50,
	"./fr-ch.js": 50,
	"./fr.js": 51,
	"./fy": 52,
	"./fy.js": 52,
	"./gd": 53,
	"./gd.js": 53,
	"./gl": 54,
	"./gl.js": 54,
	"./gom-latn": 55,
	"./gom-latn.js": 55,
	"./he": 56,
	"./he.js": 56,
	"./hi": 57,
	"./hi.js": 57,
	"./hr": 58,
	"./hr.js": 58,
	"./hu": 59,
	"./hu.js": 59,
	"./hy-am": 60,
	"./hy-am.js": 60,
	"./id": 61,
	"./id.js": 61,
	"./is": 62,
	"./is.js": 62,
	"./it": 63,
	"./it.js": 63,
	"./ja": 64,
	"./ja.js": 64,
	"./jv": 65,
	"./jv.js": 65,
	"./ka": 66,
	"./ka.js": 66,
	"./kk": 67,
	"./kk.js": 67,
	"./km": 68,
	"./km.js": 68,
	"./kn": 69,
	"./kn.js": 69,
	"./ko": 70,
	"./ko.js": 70,
	"./ky": 71,
	"./ky.js": 71,
	"./lb": 72,
	"./lb.js": 72,
	"./lo": 73,
	"./lo.js": 73,
	"./lt": 74,
	"./lt.js": 74,
	"./lv": 75,
	"./lv.js": 75,
	"./me": 76,
	"./me.js": 76,
	"./mi": 77,
	"./mi.js": 77,
	"./mk": 78,
	"./mk.js": 78,
	"./ml": 79,
	"./ml.js": 79,
	"./mr": 80,
	"./mr.js": 80,
	"./ms": 82,
	"./ms-my": 81,
	"./ms-my.js": 81,
	"./ms.js": 82,
	"./my": 83,
	"./my.js": 83,
	"./nb": 84,
	"./nb.js": 84,
	"./ne": 85,
	"./ne.js": 85,
	"./nl": 87,
	"./nl-be": 86,
	"./nl-be.js": 86,
	"./nl.js": 87,
	"./nn": 88,
	"./nn.js": 88,
	"./pa-in": 89,
	"./pa-in.js": 89,
	"./pl": 90,
	"./pl.js": 90,
	"./pt": 92,
	"./pt-br": 91,
	"./pt-br.js": 91,
	"./pt.js": 92,
	"./ro": 93,
	"./ro.js": 93,
	"./ru": 94,
	"./ru.js": 94,
	"./sd": 95,
	"./sd.js": 95,
	"./se": 96,
	"./se.js": 96,
	"./si": 97,
	"./si.js": 97,
	"./sk": 98,
	"./sk.js": 98,
	"./sl": 99,
	"./sl.js": 99,
	"./sq": 100,
	"./sq.js": 100,
	"./sr": 102,
	"./sr-cyrl": 101,
	"./sr-cyrl.js": 101,
	"./sr.js": 102,
	"./ss": 103,
	"./ss.js": 103,
	"./sv": 104,
	"./sv.js": 104,
	"./sw": 105,
	"./sw.js": 105,
	"./ta": 106,
	"./ta.js": 106,
	"./te": 107,
	"./te.js": 107,
	"./tet": 108,
	"./tet.js": 108,
	"./th": 109,
	"./th.js": 109,
	"./tl-ph": 110,
	"./tl-ph.js": 110,
	"./tlh": 111,
	"./tlh.js": 111,
	"./tr": 112,
	"./tr.js": 112,
	"./tzl": 113,
	"./tzl.js": 113,
	"./tzm": 115,
	"./tzm-latn": 114,
	"./tzm-latn.js": 114,
	"./tzm.js": 115,
	"./uk": 116,
	"./uk.js": 116,
	"./ur": 117,
	"./ur.js": 117,
	"./uz": 119,
	"./uz-latn": 118,
	"./uz-latn.js": 118,
	"./uz.js": 119,
	"./vi": 120,
	"./vi.js": 120,
	"./x-pseudo": 121,
	"./x-pseudo.js": 121,
	"./yo": 122,
	"./yo.js": 122,
	"./zh-cn": 123,
	"./zh-cn.js": 123,
	"./zh-hk": 124,
	"./zh-hk.js": 124,
	"./zh-tw": 125,
	"./zh-tw.js": 125
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 168;

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(163)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(174),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2aa3d692",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(176),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(164)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(175),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(167)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(179),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(166)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(178),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 174:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_vm._v("Powered by "), _c('a', {
    attrs: {
      "href": "https://devahoy.com",
      "target": "_blank"
    }
  }, [_vm._v("DevAhoy")])])])])])
}]}

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "new-post"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Create new post")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addPost($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Title")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPost.title),
      expression: "newPost.title"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.newPost.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPost.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Content")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPost.text),
      expression: "newPost.text"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Put your content here."
    },
    domProps: {
      "value": (_vm.newPost.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPost.text = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit",
      "value": "Add Post",
      "disabled": _vm.newPost.title === '' && _vm.newPost.text === ''
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('section', {
    staticClass: "hero is-info"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.subtitle))])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 177:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('app-header'), _vm._v(" "), _c('Post'), _vm._v(" "), _c('PostList', {
    attrs: {
      "posts": _vm.posts
    }
  }), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 178:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "posts"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Posts")]), _vm._v(" "), _vm._l((_vm.posts), function(post, index) {
    return _c('div', {
      staticClass: "box"
    }, [_c('PostItem', {
      attrs: {
        "post": post,
        "index": index
      }
    })], 1)
  })], 2)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 179:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-content columns"
  }, [_c('div', {
    staticClass: "column is-10"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.post.title))]), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.post.text) + "\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v("On " + _vm._s(_vm.post.created_at))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2 is-centered"
  }, [_c('a', {
    staticClass: "button is-danger is-outlined is-pulled-right",
    on: {
      "click": function($event) {
        _vm.removePost(_vm.index)
      }
    }
  }, [_vm._v("Delete")])])])
},staticRenderFns: []}

/***/ })

},[134]);


// WEBPACK FOOTER //
// static/js/app.efeded2107b1784e4ce0.js